import { MembershipClientService } from './membership-client-service';

export class GroupMembershipItem {
  clientService: MembershipClientService;
}
